// eslint-disable-next-line no-shadow
export enum OrderIntentionOriginEnum {
 DIRECT_SALE = 'VD',
 ORDER_INTENTION = 'IC',
}
